import React, { PureComponent } from 'react';
import ReactTooltip from 'react-tooltip';

export default class HelpTooltip extends PureComponent {

    render() {
        const id = this.props.id ||
            `help-tooltip-${ Math.random().toString(36).substr(2, 9) }`;

        const children = [
            <ReactTooltip
                key={ 2 }
                id={ id }
                className="general-tooltip help"
                globalEventOff="click focus active"
                place={ this.props.placement }
                type="light"
                effect="solid">
                <div className="help-tooltip-content">
                    { this.props.text }
                </div>
            </ReactTooltip>
        ];

        if (!this.props.excludeIcon)
            children.push((
                <span
                    key={ 1 }
                    className={ `help-tooltip${ this.props.displayInline ? ' inline' : '' } question-mark-icon` }
                    data-tip
                    data-for={ id } />
            ));

        return children;
    }
}


// WEBPACK FOOTER //
// ./src/components/portal/controls/helpTooltip.jsx